export default "__VITE_ASSET__B2SvT0U6__"